// extracted by mini-css-extract-plugin
module.exports = {"borderBox":"style_borderBox__2TICm","borderBox__title":"style_borderBox__title__bcKdM","borderBox__text":"style_borderBox__text__3aVAw"};